"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackBfcacheMetrics = trackBfcacheMetrics;
const trackFirstContentfulPaint_1 = require("./trackFirstContentfulPaint");
/**
 * BFCache keeps a full in-memory snapshot of the DOM. When the page is restored, nothing needs to be fetched, so the whole
 * viewport repaints in a single frame. Consequently, LCP almost always equals FCP.
 * (See: https://github.com/GoogleChrome/web-vitals/pull/87)
 */
function trackBfcacheMetrics(viewStart, metrics, scheduleViewUpdate) {
    (0, trackFirstContentfulPaint_1.trackRestoredFirstContentfulPaint)(viewStart.relative, (paintTime) => {
        metrics.firstContentfulPaint = paintTime;
        metrics.largestContentfulPaint = { value: paintTime };
        scheduleViewUpdate();
    });
}
//# sourceMappingURL=trackBfcacheMetrics.js.map